// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__ZsI--","question":"Question_question__11LHE","description":"Question_description__3XIcX"};